import {styled} from '@linaria/react';
import React, {useMemo} from 'react';
import {COLORS} from '../../../constants/colors';
import {useFullWidthSmallImage} from '../../molecules/FullWidthImage/useFullWidthSmallImage';

export const BlurryBackground: React.FC<{
  className?: string;
  imageUrl?: string;
  linearGradient?: string;
  color?: string;
  blur?: number;
  scale: number;
}> = ({className, imageUrl, linearGradient = '', color, blur, scale}) => {
  const backgroundImageUrl = useFullWidthSmallImage({
    ratio: '1:1',
    src: imageUrl ?? '',
  });

  const backgroundColor = useMemo(() => {
    if (color) {
      return color;
    }

    return imageUrl ? undefined : COLORS['Fill.Black'];
  }, [color, imageUrl]);

  return (
    <Wrapper
      className={className}
      $imageUrl={imageUrl ? backgroundImageUrl : ''}
      $linearGradient={linearGradient}
      $color={backgroundColor}
      $blur={blur}
      $scale={scale}
    />
  );
};

const Wrapper = styled.div<{
  $imageUrl: string;
  $linearGradient: string;
  $color?: string;
  $blur?: number;
  $scale?: number;
}>`
  content: '';
  position: absolute;
  inset: 0;
  background: ${props =>
    [`${props.$linearGradient}`, `url(${props.$imageUrl})`]
      .filter(s => s !== '')
      .join(' ')};
  background-color: ${props => (props.$color ? props.$color : '')};
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  filter: ${props => (props.$blur ? `blur(${props.$blur}px)` : '')};
  transform: scale(${props => `${props.$scale}`});
`;
